// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"88":"login-page","316":"register-page","811":"training-page","913":"library-page"}[chunkId] || chunkId) + "." + {"88":"e3a2456f","134":"7022533b","316":"174eb9e2","415":"c1eedaa4","811":"b2288a5f","913":"86c74b35","954":"a655f834"}[chunkId] + ".chunk.js";
};